import {Directive, HostListener} from '@angular/core';

@Directive({
    selector: '[checkFormError]',
    standalone: true
})
export class CheckFormErrorDirective {

  constructor(){}

  @HostListener('click', ['$event'])
  onSubmit() {
    this.getErrors();
  }

  ngAfterViewInit(){}

  private getErrors() {
    const el = document.querySelectorAll('.ng-invalid');
    if (el && el.length > 0) {
      el[0].scrollIntoView({block: 'center'})
    } else {
      const el2 = document.querySelectorAll('.text-danger');
      if (el2 && el2.length > 0) {
        el2[0].scrollIntoView({block: 'center'});
      }
    }
  }
}
